import {isProxy, reactive} from "vue";
import axios from 'axios'
import { defaultState } from './interface_default_state';
import * as config from "@/config.json";

/**
 * @deprecated ATTENTION !
 * @brief Exploité pour l'affichage des cartes de véhicules
 */
import {types} from "sass";
import List = types.List;

/* eslint-disable */

// Récupération de la variable Locale selon le premier paramètre de l'URL
const getLocation = function(): string {
	return window.location.pathname.split("/")[1].toLowerCase() == 'en' ? 'en' : 'fr';
};

// Variable pour l'expiration du TimeOut
let waitingTimeOut = 0;

const defaultState:defaultState = {
	filterCtrl: new AbortController(),
	pageCtrl: new AbortController(),
	sliderCtrl: new AbortController(),
	data: [],
	returnPath: "",
	title: "Inventaire",
	nbCars: 0,
	results: "",
	mobilesResults: "",
	orderByList: [],
	brandList: [],
	modelList: [],
	carrosserieList: [],
	categoryList: [],
	energyList: [],
	tractionList: [],
	transmissionList: [],
	engineList: [],
	intColorList:[],
	passengerList:[],
	extColorList:[],
	notModifiedData : [],
	pagesList : [],
	jsonFile: {},
	group: "",
	activeFilters: [],
	invalidList: [],
	filter: {
		order: "alphaASC",
		keyword: "",
		carrosserie: [],
		category: [],
		brand: "",
		model: "",
		traction: [],
		energy: [],
		transmission: [],
		engine: [],
		type: 0,
		intColor: [],
		extColor: [],
		nbCarsPerPage: 12,
		currentPage: 1,
		maxOdometer: 0,
		minOdometer: 0,
		maxOdometerRef: 0,
		minOdometerRef: 0,
		stepOdometer: 100,
		passenger: "",
		maxYear: 0,
		minYear: 0,
		maxYearRef: 0,
		minYearRef: 0,
		stepYear: 1,
		minPrice: 0,
		maxPrice: 0,
		minPriceRef: 0,
		maxPriceRef: 0,
		stepPrice: 100,
		viewStyle: "view_grid"
	},
	locale: getLocation(),
	isChanged: false,
	isOpen: false,
	switchDisplay: true,
	scrollPosition: null
};

const state = reactive(defaultState);

const Methods = {
	isLocaleEN: function(): boolean {
		return getLocation() == 'en';
	},

	isLocaleFR: function(): boolean {
		return getLocation() == 'fr';
	},

	insertLostData: function(newList:string[],oldList:string[]) {
		const ret:any = {}
		let tempArray:string[]=[];
		newList.forEach((newListItem:any) => {
			tempArray.push(newListItem['name']);
		});
		oldList.forEach((item:any) => {
			ret[item] = {
				name: item,
				count: 0
			}
			if(!tempArray.includes(item)){
				newList.push(ret[item]);
			}
		});
		return newList;
	},

	makePagination: function() {
		state.pagesList=[];
		const nbPage= state.nbCars/state.filter.nbCarsPerPage;
		if(nbPage>7 &&state.filter.currentPage>=4&&Math.ceil(nbPage)-state.filter.currentPage==1&&Math.ceil(nbPage)!=state.filter.currentPage){
			state.pagesList.push("1");
			state.pagesList.push("2");
			state.pagesList.push("...");
			state.pagesList.push((state.filter.currentPage-2).toString());
			state.pagesList.push((state.filter.currentPage-1).toString());
			state.pagesList.push(state.filter.currentPage.toString());
			state.pagesList.push(Math.ceil(nbPage).toString());
		}
		else if(nbPage>7 && state.filter.currentPage>4&&Math.ceil(nbPage)==state.filter.currentPage){
			state.pagesList.push("1");
			state.pagesList.push("2");
			state.pagesList.push("...");
			state.pagesList.push((state.filter.currentPage-3).toString());
			state.pagesList.push((state.filter.currentPage-2).toString());
			state.pagesList.push((state.filter.currentPage-1).toString());
			state.pagesList.push(Math.ceil(nbPage).toString());
		}
		else if(nbPage>7 && state.filter.currentPage>=5&&Math.ceil(nbPage)-state.filter.currentPage>=2){
			state.pagesList.push("1");
			state.pagesList.push("2");
			state.pagesList.push("...");
			state.pagesList.push((state.filter.currentPage-1).toString());
			state.pagesList.push(state.filter.currentPage.toString());
			state.pagesList.push((+state.filter.currentPage+1).toString());
			state.pagesList.push("...");
			state.pagesList.push(Math.ceil(nbPage).toString());
		}
		else if(nbPage>7){
			for(let i=1;i <= 6;i++){
				state.pagesList.push(i.toString());
			}
			state.pagesList.push("...");
			state.pagesList.push(Math.ceil(nbPage).toString());
		}
		else{
			for(let j=1;j <= Math.ceil(nbPage);j++){
				state.pagesList.push(j.toString());
			}
		}

	},

	/**
	 * @brief	Réinitialise les filtres avec leurs valeurs par défaut.
	 * @return	void
	 */
	resetFilter: function (url: string) {
		const inputs = document.getElementsByClassName('checkboxreset') as any;
		for (let i = 0; i < inputs.length; i++) {
			inputs[i].checked = false;
		}

		// Récupère la liste de tous les accordéons
		const accordionList: HTMLCollection = document.getElementsByClassName('inventaire__left__accord') as any;
		// Parcours tous les accordéons à la recherche uniquement de ceux actifs
		for (let accordion of Array.from(accordionList)) {
			// Le premier enfant est le titre du filtre qui doit être actif : inventaire__left__accord-title-active
			if (accordion.firstElementChild!.className != 'inventaire__left__accord-title') {
				// Écrasement de la classe active par celui non actif : inventaire__left__accord-title
				accordion.firstElementChild!.setAttribute('class', 'inventaire__left__accord-title');
				// Écrasement du style sur l'élément suivant : inventaire__left__accord-content
				accordion.firstElementChild!.nextElementSibling!.setAttribute('style', "max-height: 0px;");
			}
		}

		// Réinitialisation de l'instance de recherche
		state.filterCtrl.abort();
		state.filterCtrl = new AbortController();
		state.pageCtrl.abort();
		state.pageCtrl = new AbortController();
		state.sliderCtrl.abort();
		state.sliderCtrl = new AbortController();
		state.locale = getLocation();
		state.isChanged = false;
		state.switchDisplay = true;
		state.activeFilters = [];
		state.invalidList = [];
		state.group = "";

		// Initialisation du nom du filtre
		state.filter = {
			order: "alphaASC",
			keyword: "",
			carrosserie: [],
			category: [],
			brand: "",
			model: "",
			traction: [],
			energy: [],
			transmission: [],
			engine: [],
			type: 0,
			intColor: [],
			extColor: [],
			nbCarsPerPage: 21,
			currentPage: 1,
			minOdometer: 0,
			maxOdometer: 0,
			minOdometerRef: 0,
			maxOdometerRef: 0,
			stepOdometer: 100,
			minYear: 0,
			maxYear: 0,
			minYearRef: 0,
			maxYearRef: 0,
			stepYear: 1,
			passenger: "",
			minPrice: 0,
			maxPrice: 0,
			minPriceRef: 0,
			maxPriceRef: 0,
			stepPrice: 100,
			viewStyle: 'view_grid'
		};
		Methods.reloadPage(1);
	},

	/**
	 * @brief Préparation de l'interface pour le chargement.
	 */
	startLoadingPage: function() {
		if (document.getElementById("loading")) {
			document.getElementById("loading")!.style.display = "block";
		}

		if (document.getElementById("messageAucunVehicule"))
			document.getElementById("messageAucunVehicule")!.style.display = "none";

		if (document.getElementById("messageRechercheVehicule"))
			document.getElementById("messageRechercheVehicule")!.style.display = "none";

		if (document.getElementById("inventairePagination"))
			document.getElementById("inventairePagination")!.style.display = "none";

		if (document.getElementById("messageRefer"))
			document.getElementById("messageRefer")!.style.display = "none";
	},

	/**
	 * @brief	Teste si la valeur si différente de celle de référence.
	 * @param   string  input
	 * @param	mixed	value
	 * @return	boolean
	 */
	isNumberActiveValue: function(input: string, value: string|number) {
		// Suppression des caractères lié au format EN/FR
		value = Number(String(value).replace(/\s\.\,/g, ''));
		let active = true;
		switch (input) {
			case 'anneeMin':
				active = value > state.filter.minYearRef;
				break;
			case 'anneeMax':
				active = value < state.filter.maxYearRef;
				break;
			case 'odoMin':
				active = value > state.filter.minOdometerRef;
				break;
			case 'odoMax':
				active = value < state.filter.maxOdometerRef;
				break;
			case 'prixMin':
				active = value > state.filter.minPriceRef;
				break;
			case 'prixMax':
				active = value < state.filter.maxPriceRef;
				break;
			default:
				active = value > 0;
				break;
		}
		return active;
	},

	/**
	 * @brief	Récupère les données du filtre pour les manipuler comme des paramètres $_GET.
	 * @return	string
	 */
	mapFilterURL: function(): string {
		// Liste des choix de filtres
		let formulaire = {
			// $_GET            Filter
			'keyword':			state.filter.keyword,
			'prixMin':			state.filter.minPrice,
			'prixMax':			state.filter.maxPrice,
			'carrosserie':		state.filter.carrosserie,
			'categorie':		state.filter.category,
			'marque':			state.filter.brand,
			'model':			state.filter.model,
			'anneeMin':			state.filter.minYear,
			'anneeMax':			state.filter.maxYear,
			'odoMin':			state.filter.minOdometer,
			'odoMax':			state.filter.maxOdometer,
			'nbPassager':		state.filter.passenger,
			'traction':			state.filter.traction,
			'energie':			state.filter.energy,
			'transmission':		state.filter.transmission,
			'moteur':			state.filter.engine,
			'couleurExt':		state.filter.extColor,
			'couleurInt':		state.filter.intColor
		};
		// Liste des choix de l'interface
		let configuration = {
			// $_GET            Filter
			'order':			state.filter.order,
			'pg':				state.filter.currentPage,
			'viewStyle':		state.filter.viewStyle
		};
		// Construction du filtre global
		const filters = {...formulaire, ...configuration};

		let query = [];
		let activeFilters = [];
		for (var param in filters) {
			// @ts-ignore
			var value = filters[(param as any)];
			switch (typeof value) {
				case "string":
					if (!Methods.isNullOrWhitespace(value)) {
						// Ajoute la valeur si elle n'est pas vide
						query.push(param + "=" + String(value));
						if (Number(Object.keys(formulaire).indexOf(param)) >= 0) {
							activeFilters.push(param);
						}
					}

				case "number":
					if (Number(value) >= 0) {
						// Ajoute la valeur si elle n'est pas vide
						query.push(param + "=" + String(value));
						// Ajout du filtre uniquement s'il est différent au Min/Max de référence
						if (Methods.isNumberActiveValue(param, value) && Number(Object.keys(formulaire).indexOf(param)) >= 0) {
							param = param.replace(/(Min|Max)/, '');
							activeFilters.push(param);
							let button = '';
							switch (param) {
								case 'annee':
									button = "year";
									break;
								case 'odo':
									button = "odometer";
									break;
								case 'prix':
									button = "price";
									break;
								default:
									continue;
									break;
							}
							// Affichage du bouton s'il existe
							document.getElementById(button+'ButtonReset')?.setAttribute('style', "display: block;");
						}
					}
					break

				default:
					// Parcours de la liste
					for (const valueKey in value) {
						if (!Methods.isNullOrWhitespace(value[valueKey])) {
							// Ajoute la valeur si elle n'est pas vide
							query.push(param + "[]=" + value[valueKey]);
							if (Number(Object.keys(formulaire).indexOf(param)) >= 0) {
								activeFilters.push(param);
							}
						}
					}
					break;
			}
		}

		// Chargement des filtres actifs
		state.activeFilters = Methods.arrayUnique(activeFilters);

		// Renvoi les données du formulaire
		return '?' + query.join('&');
	},

	/**
	 * @brief	Supprime le Tag du filtre actif sélectionné et relance une nouvelle recherche.
	 * @remark	La sélection des filtres est mise à jour dans le menu latéral.
	 *
	 */
	removeActiveFilter: function(group: string, nameOfFilter: string, value: string) {
		switch (group) {
			// Supprime la sélection Marque/Modèle
			case 'brand&model':
				/**
				 *  @remark	La suppression du Modèle n'affecte pas la sélection de la Marque
				 *  		... par contre l'inverse Oui !
				 */
				if (nameOfFilter == 'brand') {
					state.filter.brand = "";
				}
				state.filter.model = "";
				break;

			// Supprime le mot-clé
			case 'keyword':
				state.filter.keyword = "";
				break;

			// Supprime le choix du nombre de passagers
			case 'passenger':
				state.filter.passenger = "";
				break;

			// Supprime le choix des gradateurs
			case 'odometer':
			case 'price':
			case 'year':
				// Réinitialise le slider
				document.getElementById(group+'ButtonReset')?.click();
				break;

			// Supprime le choix des filtres
			default:
				// Décoche la case
				document.getElementById(Methods.stringifyName(nameOfFilter, value))?.click();
				break;
		}
		// Actualisation des filtres
		CallApi.refreshFilter();
		Methods.scrollToInventaireTop(false);
	},

	/**
	 * @brief Actualise dans l'historique la nouvelle URL avec les paramètres du filtre.
	 * @param reset	: boolean 	TRUE = réinitialise les filtres
	 * @param page	: number	numéro dans la pagination
	 */
	changeFilterURL: function(reset: boolean, page = 1){
		// Initialise la page
		state.filter.currentPage = page;
		// Initialise l'URL de la page
		var refresh = state.returnPath;
		if (reset) {
			// Réinitialisation des filtres
			refresh += '?pg=' + page.toString();
		} else {
			// Récupération des filtres sous forme $_GET
			refresh += Methods.mapFilterURL();
		}
		// Remplace dans l'historique la nouvelle URL avec les paramètres du filtre
		window.history.replaceState({path: refresh}, 'Inventaire', refresh);
	},

	/**
	 * @brief Recharge les filtres de la page AVEC les sliders.
	 * @param page	: number	numéro dans la pagination
	 */
	reloadPage: function(page: number){
		Methods.scrollToInventaireTop(false);
		Methods.changeFilterURL(true, page);
		CallApi.initSearchFilter();
	},

	/**
	 * @brief Change de page sans toucher aux filtres.
	 * @param page	: number	numéro dans la pagination
	 */
	changePage: function(page: number){
		Methods.scrollToInventaireTop(false);
		Methods.changeFilterURL(false, page);
		CallApi.setDataRechercheVehicules();
	},

	/**
	 * @brief Actualise les filtres de la page SANS les sliders.
	 * @param page	: number	numéro dans la pagination
	 */
	changePageFilter: function(page: number){
		state.filter.currentPage = page;
		CallApi.refreshFilter();
	},

	/**
	 * @brief Actualise les filtres de la page SANS les sliders avec un délais d'exécition.
	 * @param page	: number	numéro dans la pagination
	 */
	changePageWaiting: function(page: number){
		// Supprime l'instruction précédente
		if (typeof(waitingTimeOut) != 'undefined') {
			clearTimeout(waitingTimeOut);
		}
		// Nouvelle recherche
		waitingTimeOut = setTimeout(function() {
			Methods.changePageFilter(page);
		}, 1000);
	},

	/**
	 * @brief Actualise TOUS les filtres de la page AVEC les sliders.
	 * @param page    : number    numéro dans la pagination
	 */
	changePageSlider: function(page: number){
		state.filter.currentPage = page;
		CallApi.refreshFilter();
	},

	putDataInArray: function(rawArray:Array<any>) {
		const ret:any = {};
		let cpt=0;
		for (const i in rawArray) {
			ret[cpt] = {
				name: rawArray[cpt]['groupValue'],
				count: rawArray[cpt]['doclist']['numFound']
			}
			cpt=cpt+1;
		}
		return Object.values(ret);
	},

	/**
	 * @brief Remplace les caractères spéciaux d'une chaîne de caractères.
	 * @param groupeName	: string    nom du groupe
	 * @param filterName    : string    contenu du filtre
	 * @return string
	 */
	stringifyName: function(groupeName: string, filterName: string): string {
		let stringify = String(groupeName).toLowerCase() + '__' + String(filterName).toLowerCase();
		stringify = stringify.replace(new RegExp(/\s/g),"_");
		stringify = stringify.replace(new RegExp(/[àáâãäå]/g),"a");
		stringify = stringify.replace(new RegExp(/æ/g),"ae");
		stringify = stringify.replace(new RegExp(/ç/g),"c");
		stringify = stringify.replace(new RegExp(/[èéêë]/g),"e");
		stringify = stringify.replace(new RegExp(/[ìíîï]/g),"i");
		stringify = stringify.replace(new RegExp(/ñ/g),"n");
		stringify = stringify.replace(new RegExp(/[òóôõö]/g),"o");
		stringify = stringify.replace(new RegExp(/œ/g),"oe");
		stringify = stringify.replace(new RegExp(/[ùúûü]/g),"u");
		stringify = stringify.replace(new RegExp(/[ýÿ]/g),"y");
		return stringify;
	},

	isChecked: function(nameOfFilter: any, value: any): boolean {
		let checked = false;
		// @ts-ignore
		if (state.filter[nameOfFilter].includes(Methods.ucFirst(value))) {
			// @ts-ignore
			let index = state.filter[nameOfFilter].indexOf(Methods.ucFirst(value));
			checked = index !== false;
		}
		return checked;
	},

	isNotChecked: function(nameOfFilter: any, value: any): boolean {
		return !Methods.isChecked(nameOfFilter, value);
	},

	isNullOrWhitespace: function(input: string): boolean {
		let output = String(input).replace(/['"\[\]]+/g, '');
		return !output || !output.trim();
	},

	arrayUnique: function (input: string[]): string[] {
		let output = input.concat();
		for(let i = 0; i < output.length; ++i) {
			for(let j = i + 1; j < output.length; ++j) {
				if(output[i] === output[j]) {
					// Élimination du doublon
					output.splice(j--, 1);
				}
			}
			// Élimination du champ vide
			if(Methods.isNullOrWhitespace(output[i])) {
				output.splice(i--, 1);
			}
		}
		return output;
	},

	checkFilterFromParams: function(params: Record<any, any>, input: string, nameOfFilter: string, ){
		// Valide que le filtre existe
		if(state.filter.hasOwnProperty(nameOfFilter)){
			// Gestion des entrées sous forme de list
			let inputText = String(params.getAll(input) as string[]).split(',');

			// Gestion des entrées sous forme de tableau
			let inputList = String(params.getAll(input+'[]') as string[]).split(',');

			// Merge des deux tableaux
			inputList = Methods.arrayUnique(inputList.concat(inputText));

			// S'assurer qu'il n'y ait au moins un élément
			if (inputList.length > 0) {
				// Mise à jour des éléments sélectionnés
				Methods.updateListFilterCheckbox(nameOfFilter, inputList);
			}
		}
	},

	getRangeFromParams: function (params: URLSearchParams, group: string, minInput: string, maxInput: string) {
		// Min
		let minValue = 0;
		if(params.get(minInput) != null){
			state.isChanged = true;
			minValue = parseInt(params.get(minInput) as string);
		}
		// Max
		let maxValue = 0;
		if(params.get(maxInput) != null){
			state.isChanged = true;
			maxValue = parseInt(params.get(maxInput) as string);
		}
		// Inversion des valeurs si Min est plus grand que Max
		if (maxValue > 0 && minValue > maxValue) {
			let temp = maxValue;
			maxValue = minValue;
			minValue = temp;
		}
		// Affectation des valeurs
		switch (group) {
			case 'odometer':
				// Odomètre Min
				state.filter.minOdometer = minValue;
				// Odomètre Max
				state.filter.maxOdometer = maxValue;
				break;

			case 'price':
				// Prix Min
				state.filter.minPrice = minValue;
				// Prix Max
				state.filter.maxPrice = maxValue;
				break;

			case 'year':
				// Année Min
				state.filter.minYear = minValue;
				// Année Max
				state.filter.maxYear = maxValue;
				break;
		}
	},

	ucFirst: function(name: string): string {
		// Manipule la chaîne si elle n'est pas vide
		return name.length > 0 ? name[0].toUpperCase() + name.substring(1) : name;
	},

	ucFirstLowerCase: function(name: string): string {
		return Methods.ucFirst(String(name).toLowerCase());
	},

	uniqueNames: function(filterName: any): string[] {
		const ret:any = {};
		for (const i in state.data) {
			const key = state.data[i][filterName];
			ret[key] = {
				name: key,
				count: ret[key] && ret[key].count ? ret[key].count + 1 : 1
			}
		}
		return Object.values(ret) as string[];
	},

	updateFilterCheckbox: function(nameOfFilter: string, value: string){
		// @ts-ignore
		if (state.filter[nameOfFilter]) {
			// @ts-ignore
			if (Methods.isChecked(nameOfFilter, value)) {
				// @ts-ignore
				const index = state.filter[nameOfFilter].indexOf(Methods.ucFirst(value));
				if (index >= 0) {
					// @ts-ignore
					state.filter[nameOfFilter].splice(index, 1);
					document.getElementById(Methods.stringifyName(nameOfFilter, value))?.setAttribute('checked', "checked");
					state.isChanged = true;
				}
			} else {
				// @ts-ignore
				state.filter[nameOfFilter].push(Methods.ucFirst(value));
				document.getElementById(Methods.stringifyName(nameOfFilter, value))?.removeAttribute('checked');
				state.isChanged = true;
			}
		}
	},

	// Met à jour des filtres à récupérer sans exécuter de requête
	updateListFilterCheckbox: function(nameOfFilter: string, SelectedCheckboxValueList: string[]){
		SelectedCheckboxValueList.forEach((SelectedCheckboxValue: string) => {
			if (nameOfFilter === "carrosserie"
				|| nameOfFilter === "category"
				|| nameOfFilter === "traction"
				|| nameOfFilter === "energy"
				|| nameOfFilter === "transmission"
				|| nameOfFilter === "engine"
				|| nameOfFilter === "intColor"
				|| nameOfFilter === "extColor") {
				// Mise à jour de la sélection
				Methods.updateFilterCheckbox(nameOfFilter, SelectedCheckboxValue);
			}
		});
	},

	newChecboxFilterSelected: function(nameOfFilter:string, SelectedCheckboxValue:string) {
		// Initialisation du nom du filtre
		state.group = "";
		if(nameOfFilter==="carrosserie"
			|| nameOfFilter==="category"
			|| nameOfFilter==="traction"
			|| nameOfFilter==="energy"
			|| nameOfFilter==="transmission"
			|| nameOfFilter==="engine"
			|| nameOfFilter==="intColor"
			|| nameOfFilter==="extColor"){
			// Désactivation du filtre uniquement lors de l'ajout
			state.group = nameOfFilter;
			// Mise à jour de la sélection
			if(state.filter[nameOfFilter]){
				if(state.filter[nameOfFilter].includes(SelectedCheckboxValue)){
					const index = state.filter[nameOfFilter].indexOf(SelectedCheckboxValue);
					if (index >= 0) {
						state.filter[nameOfFilter].splice(index, 1);
					}
				} else {
					state.filter[nameOfFilter].push(SelectedCheckboxValue);
				}
			}
		}
		// Appel de la méthode de mise à jour du filtre
		Methods.changePageFilter(1);
	},

	newInputRangeSelected: function(group: string, minValueSelected: number, maxValueSelected: number) {
		// Désactivation du filtre uniquement lors de l'ajout
		state.group = group;
		// Appel de la méthode de mise à jour du filtre
		Methods.changePageFilter(1);
	},

	inventairePositionTop: function (noMenu: boolean): number {
		let menuHeight    = 0;
		if (noMenu) {
			menuHeight    = document.getElementById("menu-container")?.clientHeight   || 0;
		}
		let addressHeigth = document.getElementById("bloc-coordonnees")?.clientHeight || 0;
		let bannerHeight  = document.getElementById("banner")?.clientHeight           || 0;
		return menuHeight + bannerHeight + addressHeigth;
	},

	scrollToInventaireTop: function (noMenu: boolean) {
		setTimeout(function() {
			scrollTo(0, Methods.inventairePositionTop(noMenu));
		}, 100);
	},

	openFilter: function () {
		state.isOpen = !state.isOpen;
		Methods.scrollToInventaireTop(true);
	},

	updateFilterContent: function (nameOfFilter: string) {
		// Récupère l'accordéon correspondant au nom du filtre
		const accordion: HTMLDivElement = document.getElementById(nameOfFilter) as any;
		// Fonctionnalité réalisée uniquement si l'accordéon est ouvert
		if (accordion.firstElementChild!.className!.indexOf('title-active') > 0) {
			// Remplacement du style sur le dernier élément : inventaire__left__accord-content
			accordion.lastElementChild!.setAttribute('style', "max-height: 100%;");
		}
	},

	switchCards: function (viewStyle: string) {
		state.switchDisplay = !state.switchDisplay;
		state.filter.viewStyle = viewStyle;
		Methods.changeFilterURL(false, state.filter.currentPage);
	}
};

//Méthode qui appelle l'Api
const CallApi = {

	initSearchFilter: function() {
		// Récupération des données passées dans l'URL
		let uri = window.location.search.substring(1);
		let params = new URLSearchParams(uri);

		// Champs String[]                    $_GET           nameOfFilter
		Methods.checkFilterFromParams(params, "carrosserie",  "carrosserie");
		Methods.checkFilterFromParams(params, "categorie",    "category");
		Methods.checkFilterFromParams(params, "traction",     "traction");
		Methods.checkFilterFromParams(params, "energie",      "energy");
		Methods.checkFilterFromParams(params, "transmission", "transmission");
		Methods.checkFilterFromParams(params, "moteur",       "engine");
		Methods.checkFilterFromParams(params, "couleurExt",   "extColor");
		Methods.checkFilterFromParams(params, "couleurInt",   "intColor");

		// Champs gradateurs Min/Max
		Methods.getRangeFromParams(params, "price", "prixMin", "prixMax");
		Methods.getRangeFromParams(params, "year", "anneeMin", "anneeMax");
		Methods.getRangeFromParams(params, "odometer", "odoMin", "odoMax");

		// Champs String/Number
		if(params.get("keyword") != null){
			state.isChanged = true;
			state.filter.keyword = params.get("keyword") as string;
		}
		// Champs Marque/Modèle
		if(params.get("marque") != null){
			state.isChanged = true;
			state.filter.brand = params.get("marque") as string;
			// Récupère le modèle
			if(params.get("model") != null){
				state.isChanged = true;
				state.filter.model = params.get("model") as string;
			}
		} else {
			// Ignore la sélection du modèle si aucune marque n'est sélectionnée
			state.filter.model = "";
		}
		// Nombre de passagers
		if(params.get("nbPassager") != null){
			state.isChanged = true;
			state.filter.passenger = params.get("nbPassager") as string;
		}
		// Vue Grille/Liste
		if(params.get("viewStyle") != null){
			state.isChanged = true;
			state.filter.viewStyle = params.get("viewStyle") as string;
			state.switchDisplay = state.filter.viewStyle != "vue_grid";
		}
		// Pagination
		if(params.get("pg") != null){
			state.isChanged = true;
			state.filter.currentPage = parseInt(params.get("pg") as string);
			// Protection contre une valeur non valide
			if (state.filter.currentPage <= 0) {
				state.filter.currentPage = 1;
			}
		}

		// Initialisation de la première recherche
		CallApi.setDataSliders();
		CallApi.setInfosFiltres();
		CallApi.setDataRechercheVehicules();
	},

	refreshFilter: function() {
		// Vider la sélection du modèle si aucune marque n'est sélectionnée
		if(state.filter.brand == "" && state.filter.model != ""){
			state.modelList = [];
			state.filter.model = "";
		}
		CallApi.setInfosFiltres();
		CallApi.setDataRechercheVehicules();
		Methods.changeFilterURL(false, state.filter.currentPage);
	},

	setDataSliders: function(){
		// Réinitialisation de l'instance de recherche
		state.sliderCtrl.abort();
		state.sliderCtrl = new AbortController();

		axios
			.get(window.location.protocol + "//" + window.location.hostname + config.getYearAndOdoMinMaxLink, {
				params: state.filter,
				signal: state.sliderCtrl.signal
			})
			.then(res => {
				// Annee Min
				state.filter.minYear         = Number(res.data.data['Annee']['min'] || 0);
				state.filter.minYearRef      = Number(res.data.data['AnneeRef']['min'] || 0);
				if(state.filter.minYearRef > 0 && state.filter.minYear < state.filter.minYearRef)
					state.filter.minYear     = state.filter.minYearRef;

				// Annee Max
				state.filter.maxYear         = Number(res.data.data['Annee']['max'] || 0);
				state.filter.maxYearRef      = Number(res.data.data['AnneeRef']['max'] || 0);
				if(state.filter.maxYearRef > 0 && state.filter.maxYear > state.filter.maxYearRef)
					state.filter.maxYear     = state.filter.maxYearRef;

				// Odomètre Min
				state.filter.minOdometer     = Number(res.data.data['Odometre']['min'] || 0);
				state.filter.minOdometerRef  = Number(res.data.data['OdometreRef']['min'] || 0);
				if(state.filter.minOdometerRef > 0 && state.filter.minOdometer < state.filter.minOdometerRef)
					state.filter.minOdometer = state.filter.minOdometerRef;

				// Odomètre Max
				state.filter.maxOdometer     = Number(res.data.data['Odometre']['max'] || 0);
				state.filter.maxOdometerRef  = Number(res.data.data['OdometreRef']['max'] || 0);
				if(state.filter.maxOdometerRef > 0 && state.filter.maxOdometer > state.filter.maxOdometerRef)
					state.filter.maxOdometer = state.filter.maxOdometerRef;

				// Prix Min
				state.filter.minPrice         = Number(res.data.data['Prix']['min'] || 0);
				state.filter.minPriceRef      = Number(res.data.data['PrixRef']['min'] || 0);
				if(state.filter.minPriceRef > 0 && state.filter.minPrice < state.filter.minPriceRef)
					state.filter.minPrice     = state.filter.minPriceRef;

				// Prix Max
				state.filter.maxPrice         = Number(res.data.data['Prix']['max'] || 0);
				state.filter.maxPriceRef      = Number(res.data.data['PrixRef']['max'] || 0);
				if(state.filter.maxPriceRef > 0 && state.filter.maxPrice > state.filter.maxPriceRef)
					state.filter.maxPrice     = state.filter.maxPriceRef;
			})
			.catch(err => {console.warn(err)});
	},

	setInfosFiltres: function(){
		// Réinitialisation de l'instance de recherche
		state.filterCtrl.abort();
		state.filterCtrl = new AbortController();

		// Suppression des données
		state.data = [];

		axios
			.get(window.location.protocol + "//" + window.location.hostname + config.infosFiltresLink, {
				params: state.filter,
				signal: state.filterCtrl.signal
			})
			.then(res => {
				// Permet de filtrer les couleurs Autres à la fin de la liste
				function validColorList(entity: any) {
					// Terme 'Autres' EN/FR
					let autreCouleur = state.jsonFile['filtre']['autreCouleur'];
					// Liste des couleurs de la recherche de base EN/FR
					let colorAvailableList = state.jsonFile['filtre']['listeCouleur'];
					// Retire et comptabilise les autres couleurs
					let cptAutre = 0;
					for (let i = 0; i < entity.length; i++) {
						// Teste si la couleur n'est pas dans la liste de base
						if (!colorAvailableList.includes(entity[i][('name' as any)].toLowerCase())) {
							cptAutre += Number.parseInt(entity[i][('count' as any)]);
							entity.splice(i, 1);
						}
					}
					// Teste si le champ 'Autres' existe déjà
					let isExists = entity.some(function (field: any) {
						return field[('name' as any)] == autreCouleur;
					});
					// Ajoute la sélection pour 'Autres' s'il n'existe pas déjà
					if (cptAutre > 0 && !isExists) {
						entity.push(({name: autreCouleur.toString(), count: cptAutre.toString()} as any));
					}
				}
				Methods.updateFilterContent('odometer');
				Methods.updateFilterContent('price');
				Methods.updateFilterContent('year');
				if (state.group != 'carrosserie' || (state.group == 'carrosserie'
					&& res.data.data['Carrosserie'].length > state.carrosserieList.length)) {
					state.carrosserieList = res.data.data['Carrosserie'];
					state.carrosserieList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.carrosserieList = Methods.insertLostData(state.carrosserieList, state.filter.carrosserie);
					Methods.updateFilterContent('carrosserie');
				}
				if (state.group != 'category' || (state.group == 'category'
					&& res.data.data['Categorie'].length > state.categoryList.length)) {
					state.categoryList = res.data.data['Categorie'];
					state.categoryList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.categoryList = Methods.insertLostData(state.categoryList, state.filter.category);
					Methods.updateFilterContent('category');
				}
				state.brandList = res.data.data['Marque'];
				if(res.data.data['Marque'].length > 0) {
					state.modelList = res.data.data['Model'];
				}
				Methods.updateFilterContent('brand&model');
				if (state.group != 'traction' || (state.group == 'traction'
					&& res.data.data['Traction'].length > state.tractionList.length)) {
					state.tractionList = res.data.data['Traction'];
					state.tractionList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.tractionList = Methods.insertLostData(state.tractionList,state.filter.traction);
					Methods.updateFilterContent('traction');
				}
				if (state.group != 'energy' || (state.group == 'energy'
					&& res.data.data['Energie'].length > state.energyList.length)) {
					state.energyList = res.data.data['Energie'];
					state.energyList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.energyList = Methods.insertLostData(state.energyList, state.filter.energy);
					Methods.updateFilterContent('energy');
				}
				if (state.group != 'transmission' || (state.group == 'transmission'
					&& res.data.data['Transmission'].length > state.transmissionList.length)) {
					state.transmissionList = res.data.data['Transmission'];
					state.transmissionList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.transmissionList = Methods.insertLostData(state.transmissionList, state.filter.transmission);
					Methods.updateFilterContent('transmission');
				}
				if (state.group != 'engine' || (state.group == 'engine'
					&& res.data.data['Moteur'].length > state.engineList.length)) {
					state.engineList = res.data.data['Moteur'];
					state.engineList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.engineList = Methods.insertLostData(state.engineList, state.filter.engine);
					Methods.updateFilterContent('engine');
				}
				if (state.group != 'intColor' || (state.group == 'intColor'
					&& res.data.data['CouleurInt'].length > state.intColorList.length)) {
					state.intColorList = res.data.data['CouleurInt'];
					state.intColorList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.intColorList = Methods.insertLostData(state.intColorList, state.filter.intColor);
					validColorList(state.intColorList);
					Methods.updateFilterContent('intColor');
				}
				if (state.group != 'extColor' || (state.group == 'extColor'
					&& res.data.data['CouleurExt'].length > state.extColorList.length)) {
					state.extColorList = res.data.data['CouleurExt'];
					state.extColorList.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
					state.extColorList = Methods.insertLostData(state.extColorList,state.filter.extColor);
					validColorList(state.extColorList);
					Methods.updateFilterContent('extColor');
				}
				state.passengerList = res.data.data['Passager'];
				Methods.updateFilterContent('passenger');
			})
			.catch(err => {console.warn(err)});
	},

	setDataRechercheVehicules: function() {
		// Réinitialisation de l'instance de recherche
		state.pageCtrl.abort();
		state.pageCtrl = new AbortController();

		// Préparation de l'interface
		Methods.startLoadingPage();

		axios
			.get(window.location.protocol + "//" + window.location.hostname + config.rechercheVoituresLink, {
				params: state.filter,
				signal: state.pageCtrl.signal
			})
			.then(res => {
				state.data              = res.data.data;
				state.title             = state.jsonFile['banner']['title'];
				state.invalidList       = res.data.meta["disabled"] as string[];
				state.nbCars            = state.invalidList.length == 0 ? Number(res.data.meta["numFound"]) : 0;
				state.results           = new String(state.jsonFile['message']['match'][state.nbCars > 1 ? 'plural' : 'single']).replace('%count%', state.nbCars.toString());
				state.mobilesResults    = new String(state.jsonFile['message']['mobile'][state.nbCars > 1 ? 'plural' : 'single']).replace('%count%', state.nbCars.toString());
				state.notModifiedData   = res.data.data;
				state.modelList         = Methods.uniqueNames("vehicule_modele_s");

				if(Number(state.nbCars) === 0 && state.invalidList.length === 0) {
					// Aucun véhicule en inventaire
					if (document.getElementById("messageAucunVehicule"))
						document.getElementById("messageAucunVehicule")!.style.display = "block";

					if (document.getElementById("messageRechercheVehicule"))
						document.getElementById("messageRechercheVehicule")!.style.display = "none";

					if (document.getElementById("messageRefer"))
						document.getElementById("messageRefer")!.style.display = "none";
				} else {
					// Au moins un véhicule en inventaire
					if (document.getElementById("messageAucunVehicule"))
						document.getElementById("messageAucunVehicule")!.style.display = "none";

					// Un filtre a été supprimé
					if(state.invalidList.length > 0) {
						if (document.getElementById("messageRechercheVehicule"))
							document.getElementById("messageRechercheVehicule")!.style.display = "block";
					} else {
						if (document.getElementById("messageRechercheVehicule"))
							document.getElementById("messageRechercheVehicule")!.style.display = "none";
					}

					// Affichage des éléments en bas d'inventaire
					if (document.getElementById("messageRefer"))
						document.getElementById("messageRefer")!.style.display = "block";

					if (document.getElementById("inventairePagination"))
						document.getElementById("inventairePagination")!.style.display = "block";
				}

				if (document.getElementById("loading"))
					document.getElementById("loading")!.style.display = "none";

				// Actualisation de la pagination
				Methods.makePagination();

				// Actualisation des filtres actifs
				if (state.isChanged) {
					Methods.changeFilterURL(false, state.filter.currentPage);
				}
				state.isChanged = false;
			})
			.catch(function (error) {
				if (error.response) {
					// Request made and server responded
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
			});
	}
};
// Exécution de la recherche initiale avec les données provenant du GET
CallApi.initSearchFilter();

if (state.returnPath == '' && state.jsonFile.length > 0) {
	state.returnPath = window.location.protocol + "//" + window.location.hostname + '/' + state.jsonFile['route']['inventaire'];
}

export default {
	state,
	...Methods,
	...CallApi,
};
